import React from "react";
import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <path
    class="cls-1"
    d="M14.43,13.07A8.42,8.42,0,0,0,12,12.75a8.37,8.37,0,0,0-2.43.32,1.75,1.75,0,0,0-.57.28v.9a4.77,4.77,0,0,1-.09,1.18A1.43,1.43,0,0,1,7.6,16.75a31.3,31.3,0,0,1-4.1.5A2.57,2.57,0,0,1,1,14.75v-1.5c0-3.72,5-6.5,11-6.5s11,2.78,11,6.47c0,.17,0,.34,0,.54v.5c0,.25,0,.36,0,.49a2.57,2.57,0,0,1-2.5,2.5,31.22,31.22,0,0,1-4.09-.5c-1,0-1.34-.82-1.39-2,0-.16,0-.29,0-.54v-.9A1.86,1.86,0,0,0,14.43,13.07ZM7,14.25v-1c0-1.77,2.2-2.5,5-2.5s5,.73,5,2.5V14.7a.49.49,0,0,1,0,.12,27.16,27.16,0,0,0,3.48.43.63.63,0,0,0,.5-.5c0-.14,0-.26,0-.51v-.48c0-.18,0-.34,0-.51,0-2.3-4-4.5-9-4.5S3,11,3,13.25v1.5a.62.62,0,0,0,.5.5A27,27,0,0,0,7,14.82C7,14.69,7,14.51,7,14.25Z"
  />,
  "GuardianCallDecline"
);
